module.exports = __webpack_public_path__ + "static/media/icon_search.f5dba463.svg";